import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useApi } from "~hooks/apiHooks/useApi";
import { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useInvalidateCache = () => {
  const request = useApi();
  const { sport, organizationId } = useParams();
  return useMutation({
    mutationFn: async () => {
      try {
        await request<DefaultOperationSuccessResponse>(`${sport}/o/${organizationId}/cache/invalidate`, { method: "POST" });
      } catch (error) {
        console.error("Failed to invalidate cache", error);
      }
    }
  });
}
